import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Paper,
} from '@mui/material';
import { CheckCircle, Cancel } from '@mui/icons-material';
import dayjs from 'dayjs';

const DataTable = ({ data, order, orderBy, handleRequestSort }) => {
  const sortData = (array) => {
    const comparator = (a, b) => {
      if (a[orderBy] < b[orderBy]) return order === 'asc' ? -1 : 1;
      if (a[orderBy] > b[orderBy]) return order === 'asc' ? 1 : -1;
      return 0;
    };
    return array.sort(comparator);
  };

  const sortedData = orderBy ? sortData([...data]) : data;

  return (
    <TableContainer
      component={Paper}
      sx={{
        flexGrow: 1,
        overflow: 'auto',
        maxHeight: 'calc(100vh - 350px)', // Ajustá este valor según lo que ocupan tus filtros
        marginBottom: '1rem',
      }}
    >
      <Table sx={{ minWidth: 650 }} aria-label="tabla de registros históricos">
        <TableHead>
          <TableRow>
            {Object.keys(data[0]).map((col) => (
              <TableCell
                key={col}
                align="center"
                sx={{
                  backgroundColor: '#1976d2',
                  color: 'white',
                  fontWeight: 'bold',
                }}
              >
                <TableSortLabel
                  active={orderBy === col}
                  direction={orderBy === col ? order : 'asc'}
                  onClick={() => handleRequestSort(col)}
                >
                  {col}
                </TableSortLabel>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedData.map((row, i) => (
            <TableRow hover key={i}>
              {Object.entries(row).map(([key, value], j) => (
                <TableCell key={j} align="center" sx={{ whiteSpace: 'nowrap' }}>
                  {key === 'Error' ? (
                    value ? (
                      <Cancel sx={{ color: 'red' }} />
                    ) : (
                      <CheckCircle sx={{ color: 'green' }} />
                    )
                  ) : key === 'Hora' && value ? (
                    dayjs.utc(value).format('DD/MM/YYYY HH:mm') + 'hs'
                  ) : key === 'Valor' && value ? (
                    parseFloat(value).toFixed(1) + '°C'
                  ) : (
                    value
                  )}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DataTable;
